module.exports = __webpack_public_path__ + "img/about1.d3fb811d.png";